module.exports = __webpack_public_path__ + "img/rocketship.c36a41ae.png";